module.exports = __webpack_public_path__ + "img/fission-func4.0b23e530.jpg";